<footer
    [class.card-without-border-radius]="
        themeService.isCardWithoutBorderRadius()
    "
    [class.card-with-box-shadow]="themeService.isCardWithBoxShadow()"
    class="footer-area text-center bg-white border-top-radius"
    [class.card-borderd]="themeService.isCardBordered()"
>
    <p>
        © <span>AluTrack Suite</span> is Proudly Owned by
        <a href="https://thummartechnologies.com/" target="_blank"
            >AluTrack Suite</a
        >
    </p>
</footer>
